import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { AnalyticsService } from '../../services/AnalyticsService'
import { captureFromLocation } from '../../utils/adAttribution'

interface AnalyticsProps {
  trackingId?: string
}

const GoogleAnalytics: React.FC<AnalyticsProps> = ({
  trackingId = import.meta.env.VITE_GA_TRACKING_ID,
}) => {
  const location = useLocation()

  useEffect(() => {
    AnalyticsService.ensureGtagLoaded(trackingId)
  }, [trackingId])

  useEffect(() => {
    captureFromLocation()
  }, [location.pathname, location.search])

  // Track page views on route changes and ensure trackingId updates are applied.
  useEffect(() => {
    AnalyticsService.trackPageView(trackingId, location.pathname)
  }, [location.pathname, trackingId])

  return null
}

// Google Search Console verification
const SearchConsoleVerification: React.FC<{
  verificationCode?: string
}> = ({
  verificationCode = import.meta.env.VITE_SEARCH_CONSOLE_VERIFICATION,
}) => {
  if (!verificationCode) return null

  return <meta name="google-site-verification" content={verificationCode} />
}

// Bing Webmaster Tools verification
const BingVerification: React.FC<{
  verificationCode?: string
}> = ({ verificationCode = import.meta.env.VITE_BING_VERIFICATION }) => {
  if (!verificationCode) return null

  return <meta name="msvalidate.01" content={verificationCode} />
}

export { GoogleAnalytics, SearchConsoleVerification, BingVerification }

export default GoogleAnalytics
